module.exports = __webpack_public_path__ + "img/clipboard-medical.6bb0ce53.svg";